import styled from "styled-components";
import { HeadLine3, BodyMedium } from '../../../components/typography/styled'

export const FormSection = styled.div`
  background-color: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  max-width: 800px;
`

export const FormRow = styled.div`
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  gap: 12px;
`

export const AuthSection = styled.div`
  background-color: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  max-width: 800px;
`

export const AuthTitle = styled(HeadLine3)`
  color: ${({ theme }) => theme.palette[800]};
  margin-bottom: 20px;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`

export const AuthUrlBox = styled.div`
  margin-top: 20px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette[100]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 4px;
`

export const AuthUrlText = styled(BodyMedium)`
  color: ${({ theme }) => theme.palette[800]};
  word-break: break-all;
  margin-bottom: 12px;
  font-family: monospace;
`

export const UrlCopyWrapper = styled.div`
  margin-top: 16px;
  padding: 12px;
  background-color: ${({ theme }) => theme.palette[100]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.palette[200]};
  }
`

export const UrlText = styled(BodyMedium)`
  color: ${({ theme }) => theme.palette[700]};
  word-break: break-all;
  font-family: monospace;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const CopyIcon = styled.img`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s;

  ${UrlCopyWrapper}:hover & {
    opacity: 1;
  }
`
